import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'bushDark',
      d: 'M1,-4h0.5v0.5h-0.5zM0.5,-3.5h1v0.5h-1zM-2.5,-3h1v0.5h-1zM0.5,-3h0.5v2h-0.5zM-2,-2.5h0.5v0.5h-0.5zM-1.5,-2h0.5v1.5h-0.5z',
    },
    {
      paint: 'tallGrass',
      d: 'M-1,-4.5h0.5v0.5h-0.5zM0,-4.5h0.5v1.5h-0.5zM-1.5,-4h1v1h-1zM-1.5,-3h0.5v1h-0.5zM2,-3h0.5v0.5h-0.5zM-0.5,-2.5h0.5v1.5h-0.5zM1.5,-2.5h1v0.5h-1zM1,-2h1v0.5h-1zM1,-1.5h0.5v0.5h-0.5zM-0.5,-1h2v0.5h-2zM-0.5,-0.5h1.5v0.5h-1.5zM-1,0h2v0.5h-2z',
    },
    { paint: 'leafLight', d: 'M-1,-3h0.5v3h-0.5zM0,-3h0.5v2h-0.5z' },
  ],
  pixels: 53,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
